export default __webpack_public_path__ + "static/media/abstract01.491a95d2.webp";